export const organization = {
  "title": "Организация",
  "type": "pointer",
  "view": {
    "name": "select-from-organizations"
  }
}

export const user = {
  "title": "Менеджер",
  "type": "pointer",
  "view": {
    "name": "select-from-user"
  }
}

export const stage = {
  "type": "string",
  "title": "Стадия",
  "enum": [
    "new",
    "work",
    "crew-assigned",
    "expect-shipment",
    "accepted-driver",
    "done",
  ],
  "oneOf": [
    {
      "const": "new",
      "title": "Новая"
    },
    {
      "const": "work",
      "title": "В работе"
    },
    {
      "const": "measurement",
      "title": "Заказ запланирован"
    },
    {
      "const": "expect-shipment",
      "title": "Готов к отгрузке"
    },
    {
      "const": "accepted-driver",
      "title": "Принят водителем"
    },
    {
      "const": "done",
      "title": "Выполнено"
    }
  ],
  "view": {
    "name": "select-from-enum"
  }
}

export const dateRange = {
  "type": "string",
  "format": "date-range",
  "title": "Дата"
}